<template>
    <div class="top-bar" tabindex="-1">
        <div class="top-bar-logo-td">
            <button type="button" class="top-bar-button" :title="$t('Main menu')" @click="clickMenu">
                <i class="fas fa-bars"></i>
            </button>
            <img src="/img/logo_inno_EDS.png" alt="Platform Logo" class="top-bar-logo" />
            <img src="/img/logo_cubic.png" alt="Platform Logo" class="top-bar-logo-min" />
            <!-- <span class="top-bar-title">{{ platformNameParts.normalPlatformName }}<span class="bold">{{
                platformNameParts.highlightedPlatformName }}</span></span>
            <span class="top-bar-title-min">{{ platformNameParts.normalPlatformName }}<span class="bold">{{
                platformNameParts.highlightedPlatformName }}</span></span> -->
        </div>
        <div class=" top-bar-buttons">
            <div class="top-bar-icons">
                <button
                    type="button"
                    class="top-bar-button"
                    :title="$t('Select your language')"
                    @click="openLanguageDropdown"
                >
                    <i class="fa-solid fa-globe"></i>
                </button>
                <!-- <button type="button" class="top-bar-button">
                    <i class="fa-solid fa-bell"></i>
                </button> -->
            </div>
            <div class="top-bar-user-td" v-if="loggedIn">
                <button type="button" class="top-bar-button-img" :title="$t('User settings')" @click="openUserSettings">
                    <!-- <span class="top-bar-hello-message">{{ $t("Hello, $USER!").replace("$USER", renderName(profileName)) }}</span> -->
                    <img v-if="profileImage" class="btn-image" :src="profileImage" />
                    <i v-else class="fa-regular fa-circle-user user-logo"></i>
                    <!-- <div class="notifications-mark" v-if="hasUnreadNotifications">&nbsp;</div> -->
                </button>
            </div>
        </div>
        <div class="top-bar-user-td" v-if="!loggedIn">
            <button type="button" class="top-bar-button" :title="$t('Select your language')" @click="selectLanguage">
                <i class="fas fa-language"></i>
            </button>
            <!-- <button type="button" class="top-bar-button" :title="$t('Change theme')" @click="invertTheme">
                <i v-if="theme === 'dark'" class="fas fa-sun"></i>
                <i v-else class="fas fa-moon"></i>
            </button> -->
            <button type="button" @click="login" class="btn btn-primary btn-top-bar-login">
                <i class="fas fa-sign-in"></i> {{ $t("Login") }}
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { ColorThemeName, getTheme, setTheme } from "@/control/app-preferences";
import { AuthController } from "@/control/auth";
import { NotificationsController } from "@/control/notifications";
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    name: "TopBar",
    emits: ["toggle-menu", "openModal"],
    data: function () {
        return {
            platformName: import.meta.env.VITE__PLATFORM_NAME || "Platform",
            loggedIn: AuthController.isAuthenticated(),
            profileImage: AuthController.ProfileImage,
            theme: getTheme(),
            profileName: AuthController.ProfileName || AuthController.Username || "",
            hasUnreadNotifications: NotificationsController.UnreadNotificationsCount > 0,
        };
    },
    methods: {
        openUserSettings: function () {
            this.$emit("openModal", "account-settings");
        },

        openNotifications: function () {
            this.$router.push({ name: "notifications" });
        },

        openLanguageDropdown: function () {
            this.$emit("openModal", "change-language");
        },

        selectLanguage: function () {
            this.$emit("openModal", "change-language-modal");
        },

        invertTheme: function () {
            setTheme(this.theme === "dark" ? "light" : "dark");
        },

        login: function () {
            this.$requireLogin();
        },

        clickMenu: function () {
            this.$emit("toggle-menu");
        },

        onAuthChanged: function () {
            this.loggedIn = AuthController.isAuthenticated();
            this.profileName = AuthController.ProfileName || AuthController.Username || "";
            this.profileImage = AuthController.ProfileImage;
        },

        onThemeChanged: function (t: ColorThemeName) {
            this.theme = t;
        },

        renderName: function (name: string): string {
            return ((name + "").split(" ")[0] + "").split(",")[0] || "???";
        },
    },
    mounted: function () {
        this.$listenOnAppEvent("auth-status-changed", this.onAuthChanged.bind(this));
        this.$listenOnAppEvent("theme-changed", this.onThemeChanged.bind(this));
        this.$listenOnAppEvent("notification-count-update", (count: number) => {
            this.hasUnreadNotifications = count > 0;
        });
    },
    beforeUnmount: function () { },
    computed: {
        platformNameParts() {
            if (this.platformName.includes('-')) {
                const [normalPlatformName, highlightedPlatformName] = this.platformName.split('-');
                return { normalPlatformName: normalPlatformName + '-', highlightedPlatformName };
            }
            return {
                normalPlatformName: this.platformName,
                highlightedPlatformName: ''
            }
        }
    }
});
</script>

<style></style>
